// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9e85d62f","746":"1ae65bfd","858":"151b17e4"}[chunkId] + ".chunk.js";
};